<div class="dialog-header">
  <div class="dialog-title">
    <div style="display: flex; align-items: center;">
      <mat-icon class="dialog-icon">folder</mat-icon>
      Dossier Details
    </div>
  </div>
  <button mat-icon-button class="button-dialog close-button" [mat-dialog-close]="false">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>

<mat-divider></mat-divider>

<mat-dialog-content #scrollContent style="overflow-y:visible">
  <!-- <p>{{'Startseite.Abwesenheitinfo' | translate}}</p> -->

  <mat-table [dataSource]="dossierDatasource" style="margin-bottom: 24px;">
    <!-- Datum Column -->
    <ng-container matColumnDef="Key">
      <mat-header-cell *matHeaderCellDef>KEY</mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (element.Key == 'Dossieransicht.Status') {
          <div>{{element.Key | translate}}</div>
        }
        @if (element.Key != 'Dossieransicht.Status') {
          <div>{{element.Key | translate}}</div>
        }
      </mat-cell>
    </ng-container>

    <!-- Betrag Column -->
    <ng-container matColumnDef="Value">
      <mat-header-cell *matHeaderCellDef>VALUE </mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (element.Key == 'Dossieransicht.Status') {
          <div>{{getStatusKey(element.Value) | translate}}</div>
        }
        @if (element.Key != 'Dossieransicht.Status') {
          <div>{{element.Value}}</div>
        }
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="dossierDisplayedColumns" style="display: none;"></mat-header-row>
    <mat-row *matRowDef="let _; columns: dossierDisplayedColumns;"></mat-row>
  </mat-table>

  <!-- Actions -->
  @if (this.data.dossierinfo != null && !this.data.dossierinfo.Abgerechnet) {
  <div>
      <div class="row no-padding">
          <button mat-button color="primary" (click)="btndirektzahlungmelden()">
              <mat-icon>payment</mat-icon>&nbsp;
              {{'Dossieransicht.Direktzahlung' | translate}}
          </button>
      </div>
      @if (this.showstundungBtn) {
      <div class="row no-padding">
          <button mat-button color="primary" (click)="btnstundungmelden()">
              <mat-icon>today</mat-icon>&nbsp;
              {{'Dossieransicht.Stundung' | translate}}
          </button>
      </div>
      }
      <div class="row no-padding">
          <button mat-button color="primary" (click)="btnadresseRechnungsempfaengermelden()">
              <mat-icon>contact_mail</mat-icon>&nbsp;
              {{'Dossieransicht.Adresse' | translate}}
          </button>
      </div>
      @if (this.showrechnungzurueckziehenBtn) {
      <div class="row no-padding">
          <button mat-button color="accent" (click)="btnrechnungzurueckziehen()">
              <mat-icon>remove</mat-icon>&nbsp;
              {{'Dossieransicht.Zurueckziehen' | translate}}
          </button>
      </div>
      }
      @if (this.data.dossierinfo.CanWithdrawLossCertificate) {
      <div class="row no-padding">
          <button mat-button color="accent" (click)="withdrawLossCertificates()" [disabled]="isUpdating">
              <mat-icon>remove</mat-icon>&nbsp;
              {{'LossCertificates.WithdrawLong' | translate}}
              @if (isUpdating) {
              <mat-icon style="margin-left: 8px;">
                  <mat-spinner diameter="20"></mat-spinner>
              </mat-icon>
              }
          </button>
      </div>
      }
      @if (this.showdossierabschliessenBtn) {
      <div class="row no-padding">
          <button mat-button color="accent" (click)="btnabschliesen()">
              <mat-icon>clear</mat-icon>&nbsp;
              {{'Dossieransicht.Abschliesen' | translate}}
          </button>
      </div>
      }
      <div class="row no-padding">
          <button mat-button color="primary" (click)="btnreclamation()">
              <mat-icon>mode_comment</mat-icon>&nbsp;
              {{'Dossier.Feedback' | translate}}
          </button>
      </div>
  </div>
  }

  <!-- Direktzahlung -->
  @if (this.showdirektzahlung) {
    <div>
      <mat-divider></mat-divider>
      <h2>{{'Dossieransicht.Zahlungmelden' | translate}}</h2>
      @for (ford of this.direktzahlung?.Forderungen; track ford; let i = $index) {
        <div class="col-md-12 row"
          style="padding:0px; margin:0px">
          <div class="col-md-4 col-left">
            <mat-form-field appearance="fill" class="login-form-field" style="width: 100%">
              <mat-label>{{'Rechnungsnummer' | translate}}</mat-label>
              <input matInput [(ngModel)]="ford.Referenz" style="margin: 0px" readonly="true">
              <button mat-flat-button color="primary" matPrefix (click)="direktZahlungAdd(ford, i)"
                matTooltip="{{'Dossier.PlusTooltip' | translate}}" class="icon-button"
                style="width:24px; min-width:24px;margin-right: 10px;padding: 0px;">
                <mat-icon style="padding:0px; margin: 0px">add</mat-icon>
              </button>
              @if (this.direktzahlung.Forderungen.length > 1) {
                <button matSuffix mat-icon-button
                  aria-label="Remove" (click)="direktZahlungRemove(i)">
                  <mat-icon style="color:darkred">close</mat-icon>
                </button>
              }
            </mat-form-field>
          </div>
          <div class="col-md-4 col-middle">
            <mat-form-field appearance="fill" style="width: 100%" class="custom-chf-prefix">
              <mat-label>{{'Betrag' | translate}}</mat-label>
              <input matInput [(ngModel)]="ford.Betrag" style="margin: 0px" required
                pattern="[0-9]+([.,][0-9]{1,2})?" type="number" min="0.01" autocomplete='off'>
                <span matPrefix>CHF&nbsp;</span>
              </mat-form-field>
            </div>
            <div class="col-md-4 col-right">
              <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                <mat-label>{{'Dossieransicht.Zahldatum' | translate}}</mat-label>
                <input matInput style="margin: 0px" [ngModel]="ford.Zahldatum | date:'dd.MM.yyyy'"
                  (ngModelChange)="ford.Zahldatum=this.oroservice.ChangeDate($event);" required
                  placeholder="{{'RequiredPlaceholder' | translate}}" autocomplete='off'>
                  <input type="hidden" [matDatepicker]="picker" [(ngModel)]='ford.Zahldatum'>
                  <mat-datepicker-toggle matSuffix [for]="picker" tabindex="-1"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
              @if (checkDirektzahlungsDatumZukunft(ford.Zahldatum)) {
                <div class="row no-padding"
                  style="margin-bottom: 4px; text-align: right">
                  <mat-error style="justify-content: right;">{{'DatumZukunft' | translate}}</mat-error>
                </div>
              }
              @if (checkDirektzahlungsVorEroefffnung(ford)) {
                <div class="row no-padding" style="margin-bottom: 4px">
                  <mat-error>{{ "Dossieransicht.ErrorVorEroeffnung" | translate }}</mat-error>
                </div>
              }
            </div>
          }
          <div class="row no-padding">
            <button mat-flat-button color="primary" (click)="melden()"
              [disabled]="isUpdating || !this.canSubmitDirektzahlung()"
              style="position: relative; top: -.75em; width: 220px; margin-top: 8px;">
              {{'Dossieransicht.Melden' | translate}}
              @if (isUpdating) {
                <mat-icon style="margin-left: 8px;"><mat-spinner
                diameter="20"></mat-spinner></mat-icon>
              }
            </button>
          </div>
        </div>
      }

      <!-- Rechnung zurückziehen -->
      @if (this.showrechnungzurueckziehen) {
        <div>
          <mat-divider></mat-divider>
          <h2>{{'Dossieransicht.Rechnungzurueckziehen' | translate}}</h2>
          @for (ford of this.data.dossierinfo?.Auftraege; track ford) {
            <div>
              @if (ford.Restbetrag > 0) {
                <mat-checkbox [(ngModel)]="ford.Selected">
                  {{ford.Referenz}} (CHF {{ford.Grundforderung | number : '1.2-2'}})
                </mat-checkbox>
              }
            </div>
          }
          @if (this.data.dossierinfo?.IsRechtlich && this.isFullStorno()) {
            <div style="margin-top: 6px;">
              <mat-checkbox [(ngModel)]="betreibungsrueckzug">
                {{'Dossieransicht.DebtEnforcementWithdrawal' | translate}}
              </mat-checkbox>
            </div>
          }
          <button class="submit-button" mat-flat-button color="primary"
            [disabled]="!this.canSubmitRechnungzurueckziehen()" (click)="openDialogZurueckziehen()">
            {{'Dossieransicht.Rechnungzurueckziehenbtn' | translate}}
          </button>
        </div>
      }

      <!-- Dossier abschliessen -->
      @if (this.showdossierabschliessen) {
        <div>
          <mat-divider></mat-divider>
          <h2>{{'Dossieransicht.Abschliesen' | translate}}</h2>
          <div style="margin-top: 6px;">
            <mat-checkbox [(ngModel)]="betreibungsrueckzug">
              {{'Dossieransicht.DebtEnforcementWithdrawal' | translate}}
            </mat-checkbox>
          </div>
          <button class="submit-button" mat-flat-button color="primary" (click)="openDialogAbschliessen()">
            {{'Dossieransicht.AbschliesenBtn' | translate}}
          </button>
        </div>
      }

      <!-- Stundung -->
      @if (this.showstundung) {
        <div>
          <mat-divider></mat-divider>
          <h2>{{'Dossieransicht.Stundungmelden' | translate}}</h2>
          @if (this.data.dossierinfo.Stundungssaldo > 31) {
            <div>
              {{'Dossieransicht.StundungAufgebraucht'| translate}}
            </div>
          }
          @if (this.data.dossierinfo.Stundungssaldo < 32) {
            <div>
              <mat-form-field appearance="fill" class="input-field" style="width:260px; margin-right: 12px;"
                floatLabel="always">
                <mat-label>
                  {{'Dossieransicht.Stundungsdauer'| translate}}
                </mat-label>
                <mat-select [(ngModel)]="this.monate" required placeholder="{{'RequiredPlaceholder' | translate}}"
                  (selectionChange)="onChangeStundung()">
                  <mat-option [value]="1">{{'Dossieransicht.Einmonat' | translate}}</mat-option>
                  @if (this.data.dossierinfo.Stundungssaldo == 0) {
                    <mat-option [value]="2">
                      {{'Dossieransicht.Zweimonate' | translate}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <button [disabled]="!this.monate" mat-flat-button color="primary" (click)="stundung()"
                style="height: 48px; position: relative; top: -.75em;">
                {{'Dossieransicht.Melden' | translate}}
              </button>
              <div>
                {{'Dossieransicht.NaechstesDatum' | translate}}: <b>{{naechstesDatum}}</b>
              </div>
            </div>
          }
        </div>
      }

      <!-- AdresseRechnungsempfaenger -->
      @if (this.showadresseRechnungsempfaenger) {
        <div>
          <mat-divider></mat-divider>
          <h2>{{'Dossieransicht.Adresseaendern' | translate}}</h2>
          <!-- <div class="row no-padding"> -->
          <app-postal-code [(Ort)]="data.dossierinfo.StandortRE.Ort" [(Plz)]="data.dossierinfo.StandortRE.Plz"
          [(Land)]="data.dossierinfo.StandortRE.Land"></app-postal-code>
        <!-- </div> -->
        <div class="row no-padding">
          <div class="col-8 col-left">
            <mat-form-field appearance="fill" class="input-field" style="width: 100%;">
              <mat-label>{{'Anschrift1' | translate}}</mat-label>
              <input matInput [(ngModel)]="data.dossierinfo.StandortRE.Anschrift" required type="text">
            </mat-form-field>
          </div>
          <div class="col-4 col-right">
            <mat-form-field appearance="fill" class="input-field" style="width: 100%;">
              <mat-label>{{'Hausnummer' | translate}}</mat-label>
              <input matInput [(ngModel)]="data.dossierinfo.StandortRE.Hausnummer" required type="text">
            </mat-form-field>
          </div>
        </div>
        <div class="row no-padding">
          <button mat-flat-button color="primary" (click)="adresseRechnungsempfaengersenden()"
            [disabled]="!canSubmitAdresseRechnungsempfaenger()"
            style="position: relative; top: -.75em; width: 220px; margin-top: 8px;">
            {{'Dossieransicht.Melden' | translate}}
          </button>
        </div>
      </div>
    }

    <!-- Reclamation -->
    @if (this.showreclamation) {
      <div>
        <mat-divider></mat-divider>
        <h2>{{'Dossier.Feedback' | translate}}</h2>
        <mat-form-field appearance="fill" style="width: 100%; margin-top: 8px;" floatLabel="always">
          <mat-label>{{'Dossier.ReclamationInfo' | translate}}</mat-label>
          <textarea matInput [(ngModel)]="reclamationBody" style="height: 120px;"
          [disabled]="isSendingReclamation"></textarea>
        </mat-form-field>
        <button class="submit-button" mat-flat-button color="primary" (click)="sendReclamation()"
          [disabled]="!canSendReclamation()">
          {{'Dossier.SendMessage' | translate}}
          @if (isSendingReclamation) {
            <mat-icon style="margin-left: 8px;"><mat-spinner
            diameter="20"></mat-spinner></mat-icon>
          }
        </button>
      </div>
    }

    @if (this.data.dossierinfo?.AbrechnungsDokument != null) {
      <div class="row no-padding">
        <button
          mat-button
          color="primary"
          (click)="downloadInvoice()">
          <mat-icon>file_download</mat-icon>&nbsp;
          {{ 'Dokumente.Abrechnung' | translate }}
      </button>
      </div>
    }
  </mat-dialog-content>
